var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative mb-4"},[(_vm.label)?_c('label',{staticClass:"absolute left-4 -top-0 bg-white px-2 text-gray-400 text-xs font-semibold pointer-events-none",staticStyle:{"transform":"translateY(-50%)"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('vue-tel-input',{ref:"vueTelInput",style:({
      background: _vm.disabled ? '#f9fafb' : 'white'
    }),attrs:{"disabled":_vm.disabled,"inputOptions":{
      showDialCode: true,
    },"enabledCountryCode":true,"preferredCountries":['IT', 'CH', 'FR', 'DE', 'GB', 'US'],"wrapper-classes":[
      'w-full',
      'rounded-full',
      'border',
      _vm.danger ? 'border-red-500 focus:ring-red-500' : 'border-gray-200 focus:ring-primary',
      'px-5 p-3',
      'focus:outline-none focus:ring-2 transition',
      _vm.loading ? 'opacity-60 pointer-events-none' : ''
    ],"input-classes":[
      'text-base',
      'font-comfortaa',
      'bg-transparent',
      'w-full',
    ],"placeholder":'Inserisci il numero di telefono'},on:{"country-changed":_vm.countryChanged,"input":_vm.handleInput}}),(_vm.invalid && _vm.tempValue.length > 0)?_c('div',{staticClass:"text-red-500 text-sm mt-1"},[_vm._v(" Numero di telefono non valido ")]):_vm._e(),(_vm.loading)?_c('div',{staticClass:"absolute right-4 top-1/2 transform -translate-y-1/2"},[_c('svg',{staticClass:"animate-spin h-5 w-5 text-primary",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24"}},[_c('circle',{staticClass:"opacity-25",attrs:{"cx":"12","cy":"12","r":"10","stroke":"currentColor","stroke-width":"4"}}),_c('path',{staticClass:"opacity-75",attrs:{"fill":"currentColor","d":"M4 12a8 8 0 018-8v8z"}})])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }